import { Logo } from '@/components/logo';

/** The product mark above a single-column page (sign-in, invitation, setup). Lanuq has no
 *  symbol yet, so it is the wordmark (owner, 2026-11-03); the flower now belongs to Espaço
 *  Aflorar, the first clinic. */
export function AflorarMark({ className }: { className?: string; imgClassName?: string }) {
  return (
    <div className={className ?? 'mb-8 flex justify-center'}>
      <Logo size={32} />
    </div>
  );
}
